exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".languageContainer[data-v-5e594342] {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 200px;\n}\n.languageContainer img[data-v-5e594342] {\n  cursor: pointer;\n  width: 4rem !important;\n  height: 2rem !important;\n}\n@media only screen and (min-width: 501px) {\n.languageContainer[data-v-5e594342] {\n    justify-content: flex-end;\n}\n}", ""]);

// exports
